import React, { useEffect, useState } from 'react';
import { Container, Card, Spinner, Alert, Accordion, Row, Col, Form, InputGroup } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import api from '../../api/apiClient';
import LandingNavbar from './Navbar';

const FAQPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredFaqs, setFilteredFaqs] = useState([]);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await api.faqs.listPublic();
        if (response.data?.success) {
          setFaqs(response.data.data || []);
          setFilteredFaqs(response.data.data || []);
        } else {
          setError(response.data?.message || 'Failed to load FAQs');
        }
      } catch (err) {
        const message = err.response?.data?.message || err.message;
        setError(message || 'Failed to load FAQs');
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  useEffect(() => {
    if (searchQuery.trim() === '') {
      setFilteredFaqs(faqs);
    } else {
      const query = searchQuery.toLowerCase();
      const filtered = faqs.filter(faq => 
        faq.question.toLowerCase().includes(query) || 
        (faq.answer_html && faq.answer_html.toLowerCase().includes(query))
      );
      setFilteredFaqs(filtered);
    }
  }, [searchQuery, faqs]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="min-vh-100 d-flex flex-column bg-light">
      <LandingNavbar />
      
      <div className="flex-grow-1 pt-5 mt-5">
        <Container className="py-4">
          <Card className="shadow-sm mb-4">
            <Card.Body className="p-4 p-md-5">
              <h1 className="text-center mb-4">Frequently Asked Questions</h1>
              <p className="text-center text-muted mb-4">
                Find answers to the most common questions about our platform.
              </p>

              <Row className="justify-content-center mb-5">
                <Col md={8}>
                  <InputGroup>
                    <InputGroup.Text className="bg-white">
                      <FaSearch className="text-muted" />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search questions..."
                      value={searchQuery}
                      onChange={handleSearchChange}
                      className="border-start-0"
                    />
                  </InputGroup>
                </Col>
              </Row>

              {loading && (
                <div className="text-center py-4">
                  <Spinner animation="border" />
                </div>
              )}

              {error && !loading && (
                <Alert variant="danger">
                  {error}
                </Alert>
              )}

              {!loading && !error && filteredFaqs.length === 0 && (
                <div className="text-center text-muted py-4">
                  {searchQuery ? 'No FAQs match your search criteria' : 'No FAQs have been published yet'}
                </div>
              )}

              {!loading && !error && filteredFaqs.length > 0 && (
                <Accordion defaultActiveKey="0">
                  {filteredFaqs.map((faq, index) => (
                    <Accordion.Item eventKey={index.toString()} key={faq.id} className="mb-3 border rounded shadow-sm">
                      <Accordion.Header>{faq.question}</Accordion.Header>
                      <Accordion.Body>
                        <div dangerouslySetInnerHTML={{ __html: faq.answer_html || '' }} />
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              )}
            </Card.Body>
          </Card>
        </Container>
      </div>

      <footer className="bg-dark text-white py-4 mt-auto">
        <Container>
          <div className="text-center">
            <p className="mb-0">© {new Date().getFullYear()} Enable LXP. All rights reserved.</p>
          </div>
        </Container>
      </footer>
    </div>
  );
};

export default FAQPage;
